import { FIRST_LETTER, NON_ALPHANUM_GLOBAL, NON_DIGITS_GLOBAL } from './constants';
import { isFunction, isString } from './typeChecks';

var capitalizeFirst = s => {
  return isString(s) ? upperCase(s[0]) + s.substring(1) : '';
};

var safeTrim = function safeTrim(str) {
  var defaultReturn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : str;
  return isString(str) ? str.trim() : defaultReturn;
};

var lowerCase = s => setCase(s, 'toLowerCase');

var reverseString = str => {
  if (!isString(str)) {
    return '';
  }

  if (str.length < 2) {
    return str;
  }

  return reverseString(str.substr(1)) + str[0];
};

var setCase = (s, fn) => {
  return isString(s) && isFunction(s[fn]) ? s[fn]() : '';
};

var stripNonDigits = s => {
  return isString(s) ? safeNormalize(s).replace(NON_DIGITS_GLOBAL, '') : '';
};

var stripNonAlphaNum = s => {
  return isString(s) ? safeNormalize(s).replace(NON_ALPHANUM_GLOBAL, '') : '';
};

var stripPrefix = (s, prefixRegEx) => {
  return s.replace(prefixRegEx, '').replace(FIRST_LETTER, lowerCase);
};

var upperCase = s => setCase(s, 'toUpperCase');

var padLeft = (s, length, pad) => {
  while (s.length < length) {
    s = pad + s;
  }

  return s;
};

var safeNormalize = function safeNormalize(str) {
  var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NFKD';
  var defaultReturn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : str;
  return isString(str) && isFunction(str.normalize) ? str.normalize(form) : defaultReturn;
};

var splice = (str, idx, insert) => str.slice(0, idx) + insert + str.slice(idx);

export { capitalizeFirst, lowerCase, reverseString, safeTrim, stripNonDigits, stripNonAlphaNum, stripPrefix, upperCase, padLeft, safeNormalize, splice };